/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeadAssignmentRequest
 */
export interface UpdateLeadAssignmentRequest {
    /**
     * 
     */
    user_id: string;
}

/**
 * Check if a given object implements the UpdateLeadAssignmentRequest interface.
 */
export function instanceOfUpdateLeadAssignmentRequest(value: object): value is UpdateLeadAssignmentRequest {
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    return true;
}

export function UpdateLeadAssignmentRequestFromJSON(json: any): UpdateLeadAssignmentRequest {
    return UpdateLeadAssignmentRequestFromJSONTyped(json, false);
}

export function UpdateLeadAssignmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeadAssignmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'user_id': json['user_id'],
    };
}

export function UpdateLeadAssignmentRequestToJSON(json: any): UpdateLeadAssignmentRequest {
    return UpdateLeadAssignmentRequestToJSONTyped(json, false);
}

export function UpdateLeadAssignmentRequestToJSONTyped(value?: UpdateLeadAssignmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['user_id'],
    };
}

